import { render, staticRenderFns } from "./riskMsgDialog.vue?vue&type=template&id=adde6860&scoped=true"
import script from "./riskMsgDialog.vue?vue&type=script&lang=js"
export * from "./riskMsgDialog.vue?vue&type=script&lang=js"
import style0 from "./riskMsgDialog.vue?vue&type=style&index=0&id=adde6860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adde6860",
  null
  
)

export default component.exports